import { useEffect, useState } from 'react'

import { TourDefinition } from '@ui/components/Tourtip/Tourtip'

import { useTradingAccountsTour } from './definitions/useTradingAccountsTour'
import { useWalletsTour } from './definitions/useWalletsTour'
import { useTourRoutesURL } from './useTourRoutesURL'

export const useTourRoute = (route: string) => {
  const [tour, setTour] = useState<TourDefinition | null>(null)
  const { isWalletsRoute, isTradingAccountsRoute } = useTourRoutesURL(route)

  const filterTourSteps = (tour: TourDefinition): TourDefinition => ({
    ...tour,
    steps: tour.steps.filter((step) => step.condition !== false),
  })

  const walletsTour = useWalletsTour(isWalletsRoute)
  const tradingAccountsTour = useTradingAccountsTour(isTradingAccountsRoute)

  useEffect(() => {
    const tourMap: Array<[boolean, TourDefinition | null]> = [
      [isWalletsRoute, walletsTour],
      [isTradingAccountsRoute, tradingAccountsTour],
    ]

    const activeTour = tourMap.find(([isRoute]) => isRoute)?.[1]

    if (!activeTour) {
      setTour(null)
      return
    }

    setTour(filterTourSteps(activeTour))
  }, [isWalletsRoute, isTradingAccountsRoute, walletsTour, tradingAccountsTour])

  return tour
}
